import {
  NotificationKind,
  NotificationSource,
} from "@redotech/redo-merchant-notifications/notification-definitions";
import { notificationIdFormat } from "@redotech/redo-notifications-id";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const notificationSchema = z.object({
  notificationId: notificationIdFormat.schema,
  source: createEnum(NotificationSource),
  kind: createEnum(NotificationKind),
  title: z.string(),
  message: z.string(),
  url: z.string().nullable(),
  metadata: z.unknown().nullable(),
  createdAt: z.date(),
  readAt: z.date().nullable(),
});

export const getCurrentUserNotifications = {
  name: "getCurrentUserNotifications" as const,
  input: z.object({
    limit: z.number().int().min(1).max(100).optional(),
    unreadOnly: z.boolean().optional(),
    unreadFirst: z.boolean().optional(),
  }),
  output: z.object({
    notifications: z.array(notificationSchema),
    unreadCount: z.number().int().nonnegative(),
  }),
};
